import React, { useEffect, useState } from 'react'
import { Upload, UploadProps, message } from 'antd'
import { FormattedMessage } from '~/translations/utils'
import { getToken } from '../../../../utils/token'

type Props = {
  attachments: number[]
  setAttachments: React.Dispatch<React.SetStateAction<number[]>>
}

const Attachments: React.FC<Props> = ({ attachments, setAttachments }) => {
  const [fileList, setFileList] = useState<any[]>([])

  useEffect(() => {
    if (!attachments.length && fileList) {
      setFileList([])
    }
  }, [attachments])

  const props: UploadProps = {
    name: 'file',
    data: {
      ticketId: null,
      primaryEmail: false,
      public: false,
    },
    headers: {
      'X-AUTH-TOKEN': getToken(),
    },
    action:
      'https://' +
      process.env.AGENT_DOMAIN +
      '/api/phone/tickets/attachment/upload',
    multiple: true,

    onChange(info) {
      let files = [...info.fileList]

      setFileList(files)

      if (info.file.status === 'done') {
        message.success(
          info.file.name +
            ' ' +
            intl.formatMessage({ id: 'ticket / attachment / success' })
        )
        setAttachments([...attachments, info.file.response.id])
      } else if (info.file.status === 'error') {
        message.error(
          info.file.name +
            ' ' +
            intl.formatMessage({ id: 'ticket / attachment / error' })
        )
      }
    },

    onRemove(file) {
      const newAttachments = attachments.filter(
        item => item != file.response.id
      )

      setAttachments(newAttachments)
    },
  }

  return (
    <Upload {...props} fileList={fileList} className="ticket-editor__upload">
      <button className="addAttachment button" type="button">
        <span className="far fa-paperclip  ticket-editor__icon--size mr-2"></span>
        <FormattedMessage id="ticket / add / attachment" />
      </button>
    </Upload>
  )
}

export default Attachments
